import { render, staticRenderFns } from "./DesktopManagerComponent.vue?vue&type=template&id=1aebf4e4"
import script from "./DesktopManagerComponent.vue?vue&type=script&lang=js"
export * from "./DesktopManagerComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports